import { render, staticRenderFns } from "./StrHedefKartlari.vue?vue&type=template&id=364f7654"
import script from "./StrHedefKartlari.vue?vue&type=script&lang=js"
export * from "./StrHedefKartlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports